import { QueryKeyConfig, MutationKeyConfig } from './api-helper';

export const officeApiKeyStore = {
  createOffice: (): MutationKeyConfig => ({
    mutationKey: [`CREATE_OFFICE`],
    route: `/Office`,
    action: 'POST',
  }),
  getQBOTerms: (): QueryKeyConfig => ({
    queryKey: [`GET_OFFICE_QBTerms`],
    route: `/Office/QBOTerms`,
  }),
  updateOffice: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_OFFICE`],
    route: `/Office`,
    action: 'PUT',
  }),
  // deleteOffice: (id: number): MutationKeyConfig => ({
  //   mutationKey: [`DELETE_OFFICE`, id],
  //   route: `/Office/${id}`,
  //   action: 'DELETE',
  // }),
  getAllOffices: (): QueryKeyConfig => ({
    queryKey: [`GET_OFFICES`],
    route: `/Office`,
  }),
  getCustomersOffices: (customerIDs: number[]): QueryKeyConfig => ({
    queryKey: [`GET_CUSTOMERS_OFFICESS`, ...(customerIDs ? customerIDs : [])],
    route: `/Office/GetOfficesForMultiCustomers?${customerIDs?.map((o) => `CustomerIDs=${o}`)?.join('&')}`,
    isEnabled: customerIDs !== undefined && customerIDs !== null,
  }),
  getCustomerOffices: (id?: any): QueryKeyConfig => ({
    queryKey: [`GET_OFFICES`, id],
    route: `/Office?customerid=${id}`,
    isEnabled: !!id && id !== undefined && id !== null,
  }),
  getOffice: (id: any): QueryKeyConfig => ({
    queryKey: [`GET_OFFICES`, id],
    route: `/Office/details/${id}`,
  }),
  getOfficeContracts: (id: any): QueryKeyConfig => ({
    queryKey: [`GET_OFFICES`, id],
    route: `/Office/${id}/contracts`,
  }),
  getOfficeProfileStatistics: (officeID?: number, formDate?: any, toDate?: any): QueryKeyConfig => ({
    queryKey: [`GET_OFFICE_PROFILESTAT`, officeID, formDate, toDate],
    route: `/Office/ProfileStatistics?ID=${officeID}&FromDate=${formDate}&ToDate=${toDate}`,
    isEnabled: !!officeID,
  }),
  validateOffice: (customerID: any,officeID:any, officeName: string): QueryKeyConfig => ({
    queryKey: [`VALIDATE_OFFICE`, customerID,officeID, officeName],
    route: `/Office/OfficeExists?CustomerID=${customerID}&OfficeID=${officeID}&OfficeName=${officeName}`,
  }),
  getOfficeCode: (customerID?: any): QueryKeyConfig => ({
    queryKey: [`GET_OFFICE_CODE_BY_CUSTOMER_ID`, customerID],
    route: `/Office/${customerID}/Code`,
    isEnabled: !!customerID,
  }),
  getInheritOffice: (officeID?: any): QueryKeyConfig => ({
    queryKey: [`GET_INHERIT_OFFICE`, officeID],
    route: `/Office/GetOfficeDetailsToInherit/${officeID}`,
    isEnabled: officeID !== undefined && officeID !== null,
  }),
};
